import React from "react";
import { useFormikContext } from "formik";
import { TextInput, GeneralSelectInput } from "components/molecules";
import { PreScreeningFormValues } from "types";
import { getSortedDestinations, getSortedProgramLevels } from "services";
import jsonData from "assets/json/Tags.json";

const disabledProgramLevels: string[] = [];
const disabledDestinations: string[] = [
  "canada",
  "china",
  "germany",
  "japan",
  "malaysia",
  "new zealand",
  "singapore",
  "south korea",
  "uk",
  "usa",
];

const programLevelOptions = getSortedProgramLevels(jsonData).map((level) => ({
  value: level.toLowerCase(),
  label: level,
  isDisabled: disabledProgramLevels.includes(level.toLowerCase()),
}));

const destinationOptions = getSortedDestinations(jsonData).map((dest) => ({
  value: dest.toLowerCase(),
  label: dest,
  isDisabled: disabledDestinations.includes(dest.toLowerCase()),
}));

const PSPreferenceSection: React.FC = () => {
  const { values, errors, touched, handleChange, handleBlur } =
    useFormikContext<PreScreeningFormValues>();

  return (
    <div className="preference-section">
      <h2>Preference</h2>
      <p>Indicate your preferences.</p>

      <GeneralSelectInput
        id="preferredLevel"
        label="Preferred Level"
        options={programLevelOptions}
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.preferredLevel}
        error={errors.preferredLevel}
        touched={touched.preferredLevel}
      />

      <TextInput
        id="preferredSubject"
        label="Preferred Subject"
        placeholder="Enter preferred subject"
        getFieldProps={() => ({
          value: values.preferredSubject,
          onChange: handleChange,
          onBlur: handleBlur,
        })}
        error={errors.preferredSubject}
        touched={touched.preferredSubject}
      />

      <GeneralSelectInput
        id="preferredCountry"
        label="Preferred Country"
        options={destinationOptions}
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.preferredCountry}
        error={errors.preferredCountry}
        touched={touched.preferredCountry}
      />
    </div>
  );
};

export default PSPreferenceSection;
